import { useEffect, useState } from "react";
import { despathDateOrdersClientByMonthAndYearEvent } from "../../_events/departures/find_departures.event";
import { message } from "antd";

export const useDespathClientsByMonthAndYear = () => {

    const [ data, setData ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ month, setMonth ] = useState(new Date().getMonth() + 1);
    const [ year, setYear ] = useState(new Date().getFullYear());

    useEffect(() => {
        setLoading(true);
        despathDateOrdersClientByMonthAndYearEvent(month, year)
        .then(json => {
            setData(json.list);
            setLoading(false);
        })
        .catch(err => {
            message.error(err.message);
            setLoading(false);
        });
    }, [month, year]);
    
    return {
        loading, data, month, year, setMonth, setYear
    };
}